import $ from 'jquery';
import React, { Component } from 'react';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { DamService } from '../../services/dam';
import { UserService } from '../../services/user';
import { WorkflowsService } from '../../services/workflows';
import { RDP_TRANSLATE } from '../../translate/translate';
import RDP_CONFIG from '../../config';
import Swal from 'sweetalert2';
import './pdf-editor.css';

export default class ViewPdfEditor extends Component {

    constructor(props) {
        super(props);

        this.state = {
            "pdf": {
                "title": "",
                "author": "",
                "isbn": "",
                "type": "FACSIMILAR",
                "sunflower_id": "",
                "thumb": "",
                "file": null,
                "summary": []
            },
            "displayed_preloader": this.props.match.params.content_uid !== undefined,
            "labels": RDP_TRANSLATE[RDP_CONFIG.language]().pdf_editor || {},
            "active_mode": "edit",
            "is_saving": false,
            "show_loader": true,
            "loader_text": "Carregando...",
            "manifest": null,
            "pdf_pages": [],
            "total_pages": 0,
            "enabled_workflows": false,
            "rendering_progress": 0,
            "is_rendering": false,
        }

        this.onTitleChange = this.onTitleChange.bind(this);
        this.onAuthorChange = this.onAuthorChange.bind(this);
        this.onCoverImageClick = this.onCoverImageClick.bind(this);
        this.onCoverImageChange = this.onCoverImageChange.bind(this);
        this.onPdfFileSelect = this.onPdfFileSelect.bind(this);
        this.onPdfFileChange = this.onPdfFileChange.bind(this);
        this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
        this.onSummaryItemChange = this.onSummaryItemChange.bind(this);
        
        this.pdfFileInputRef = React.createRef();
        this.coverImageInputRef = React.createRef();
    }

    componentWillMount() {
        // Carrega PDF.js via CDN
        if (!window.pdfjsLib) {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js';
            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
            };
            document.head.appendChild(script);
        }
        
        if (this.props.match.params.content_uid !== undefined) {
            this.getProcesses();
            this.dispatchConnectorStatusWorkflow();
            this.getContent();
        } else {
            const manifest = this.getManifestStructure();
            this.setState({
                "manifest": manifest,
                "show_loader": false,
            });
        }
    }

    dispatchConnectorStatusWorkflow() {
        var enabledWorkflows = false;
        var connectors = UserService.getAllConnectors();
        for (var i = 0; i < connectors.length; i++) {
            var configuration = JSON.parse(connectors[i].configuration);
            if (configuration.name === "Workflow") {
                enabledWorkflows = true;
            }
        }
        this.setState({ "enabled_workflows": enabledWorkflows });
    }

    hasConnectorWorflow() {
        var enabledWorkflows = false;
        var connectors = UserService.getAllConnectors();
        for (var i = 0; i < connectors.length; i++) {
            var configuration = JSON.parse(connectors[i].configuration);
            if (configuration.name === "Workflow") {
                enabledWorkflows = true;
            }
        }
        return enabledWorkflows;
    }

    async getProcesses() {
        if (this.hasConnectorWorflow()) {
            var processes = await WorkflowsService.getProcesses();
            this.setState({ "processes": processes });
        }
    }

    async onSaveButtonClick() {
        const { manifest, pdf } = this.state;
        
        if (!pdf.file) {
            Swal.fire('Erro', 'Selecione um arquivo PDF', 'error');
            return;
        }

        this.setState({
            "is_saving": true,
            "show_loader": true,
            "loader_text": "Aguarde, salvando conteúdo...",
        });

        var _this = this;
        manifest.metadata.title = pdf.title;
        manifest.metadata.author = pdf.author;
        manifest.metadata.isbn = pdf.isbn;
        manifest.metadata.type = pdf.type;
        manifest.metadata.sunflower_id = pdf.sunflower_id;

        await this.saveContent(pdf.title, manifest);
    }

    generateCustomDateString() {
        var date = new Date();
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var hours = ("0" + date.getHours()).slice(-2);
        var minutes = ("0" + date.getMinutes()).slice(-2);
        var seconds = ("0" + date.getSeconds()).slice(-2);
        return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds;
    }

    async saveContent(name, content) {
        var _this = this;
        var zip = new JSZip();
        const config = RDP_CONFIG;

        content.last_updated = this.generateCustomDateString();

        zip.file("manifest.json", JSON.stringify(content, null, 2));
        zip.file("summary.json", JSON.stringify(this.state.pdf.summary, null, 2));

        await this.saveAsset(this.state.pdf.file, zip);
        if (this.state.pdf.thumb) {
            await this.saveAsset(this.state.pdf.thumb, zip);
        }

        zip.generateAsync({ type: "blob" }).then(async function (blob) {
            var file = _this.blobToFile(blob, name + ".zip");
            var connectorUid = UserService.getActiveProject().connectors[0].uid;
            var userData = UserService.getUser();
            var type = userData.type;
            var accessToken = userData.access_token;

            var fd = new FormData();
            fd.append('file', file, `${name}.rdppdf`);
            fd.append("content_info", `file_name=${name}`);
            fd.append("content_info", `title=${name}`);
            fd.append("content_type", "digitalpages/pdf");

            var isUpdate = _this.props.match.params.content_uid !== undefined;
            var url = isUpdate 
                ? `https://${config.domain}/storage/${config.apiVersion}/content?uid=${_this.props.match.params.content_uid}&manual_project_uid=${UserService.getActiveProject().uid}`
                : `https://${config.domain}/storage/${config.apiVersion}/upload/connector/uid/${connectorUid}`;

            $.ajax({
                url: url,
                type: isUpdate ? "PUT" : "POST",
                data: fd,
                contentType: false,
                processData: false,
                headers: {
                    "Authorization": type + " " + accessToken,
                    "Project-Key": config.projectKey,
                    "Api-Env": config.apiEnv
                },
                success: function (response) {
                    var uid = response[0].document.content_uid;
                    _this.setState({
                        "is_saving": false,
                        "show_loader": false,
                    });
                    Swal.fire('Sucesso', 'Conteúdo salvo com sucesso!', 'success').then(() => {
                        if (!isUpdate) {
                            window.location = window.location.origin + window.location.pathname + "#/pdf-editor/" + uid;
                        } else {
                            _this.redirectToHome();
                        }
                    });
                },
                error: function (error) {
                    console.error(error);
                    _this.setState({
                        "is_saving": false,
                        "show_loader": false,
                    });
                    Swal.fire('Erro', 'Erro ao salvar PDF', 'error');
                }
            });
        });
    }

    async saveAsset(asset, zip) {
        if (asset.file) {
            zip.file(asset.name, asset.file);
        } else if (asset.uid) {
            var userData = UserService.getUser();
            var url = DamService.getFileUrl(asset.uid, userData.access_token);
            var data = await JSZipUtils.getBinaryContent(url);
            zip.file(asset.name, data, { binary: true });
        }
    }

    getManifestStructure() {
        return {
            "type": "digitalpages/pdf",
            "path": null,
            "default_target": "file.pdf",
            "default_thumb": "thumb.jpg",
            "default_thumb_dir": "/",
            "default_summary": "summary.json",
            "last_updated": null,
            "changes": [],
            "version": "1.3",
            "metadata": {
                "title": "",
                "isbn": null,
                "type": "FACSIMILAR",
                "author": "",
                "sunflower_id": ""
            },
            "assets": null
        };
    }

    blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
    }

    async getContent() {
        var _this = this;
        var userData = UserService.getUser();
        var contentUid = this.props.match.params.content_uid;

        try {
            var content = await DamService.getContentZip(contentUid, userData.access_token);
            var zip = await JSZip.loadAsync(content);
            
            var manifestFile = await zip.file("manifest.json").async("string");
            var manifest = JSON.parse(manifestFile);

            var summaryFile = await zip.file("summary.json").async("string");
            var summary = JSON.parse(summaryFile);

            var pdfFile = await zip.file("file.pdf").async("blob");
            var thumbFile = zip.file("thumb.jpg") ? await zip.file("thumb.jpg").async("blob") : null;

            var pdf = {
                "title": manifest.metadata.title,
                "author": manifest.metadata.author || "",
                "isbn": manifest.metadata.isbn || "",
                "type": manifest.metadata.type || "FACSIMILAR",
                "sunflower_id": manifest.metadata.sunflower_id || "",
                "thumb": thumbFile ? { file: thumbFile, name: "thumb.jpg" } : null,
                "file": { file: pdfFile, name: "file.pdf" },
                "summary": summary
            };

            _this.setState({
                "manifest": manifest,
                "pdf": pdf,
                "show_loader": false,
                "displayed_preloader": false,
            });

            _this.loadPdfPages(pdfFile);
        } catch (error) {
            console.error(error);
            Swal.fire('Erro', 'Erro ao carregar PDF', 'error').then(() => {
                _this.redirectToHome();
            });
        }
    }

    async loadPdfPages(pdfBlob) {
        if (!window.pdfjsLib) {
            setTimeout(() => this.loadPdfPages(pdfBlob), 500);
            return;
        }

        try {
            this.setState({ is_rendering: true, rendering_progress: 0 });
            
            const arrayBuffer = await pdfBlob.arrayBuffer();
            const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
            const totalPages = pdf.numPages;
            const pages = [];

            for (let i = 1; i <= totalPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 0.3 });
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({ canvasContext: context, viewport: viewport }).promise;
                pages.push({
                    pageNumber: i,
                    thumbnail: canvas.toDataURL('image/jpeg', 0.7)
                });
                
                this.setState({ 
                    rendering_progress: Math.round((i / totalPages) * 100)
                });
            }

            this.setState({ 
                pdf_pages: pages, 
                total_pages: totalPages,
                is_rendering: false,
                rendering_progress: 100
            });
        } catch (error) {
            console.error('Erro ao renderizar páginas:', error);
            this.setState({ is_rendering: false });
        }
    }

    onTitleChange(e) {
        var pdf = this.state.pdf;
        pdf.title = e.target.value;
        this.setState({ pdf });
    }

    onAuthorChange(e) {
        var pdf = this.state.pdf;
        pdf.author = e.target.value;
        this.setState({ pdf });
    }

    onCoverImageClick() {
        this.coverImageInputRef.current.click();
    }

    onCoverImageChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            Swal.fire('Erro', 'Por favor, selecione uma imagem válida', 'error');
            return;
        }

        var pdf = this.state.pdf;
        pdf.thumb = { file: file, name: "thumb.jpg" };
        this.setState({ pdf });
    }

    onPdfFileSelect() {
        this.pdfFileInputRef.current.click();
    }

    onPdfFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== 'application/pdf') {
            Swal.fire('Erro', 'Por favor, selecione um arquivo PDF válido', 'error');
            return;
        }

        var pdf = this.state.pdf;
        pdf.file = { file: file, name: "file.pdf" };
        this.setState({ pdf });

        this.loadPdfPages(file);
    }

    getFilePath(fileUid) {
        const accessToken = UserService.getUser().access_token;
        return `https://${RDP_CONFIG.domain}/storage/v1.0/content?uid=${fileUid}&project_key=${RDP_CONFIG.projectKey}&api_env=${RDP_CONFIG.apiEnv}&access_token=${accessToken}`;
    }

    getCoverImage(image) {
        if (!image) return null;
        if (image.file) return URL.createObjectURL(image.file);
        if (image.uid) return this.getFilePath(image.uid);
        return null;
    }

    redirectToHome() {
        const isEmbedRoute = window.location.hash.includes('/embed/pdf-editor');
        const targetRoute = isEmbedRoute ? "#/embed" : "#/";
        window.location = window.location.origin + window.location.pathname + targetRoute;
    }

    onSummaryItemChange(pageNumber, label) {
        var pdf = this.state.pdf;
        var existingIndex = pdf.summary.findIndex(item => item.page === pageNumber);
        
        if (label.trim() === "") {
            if (existingIndex !== -1) {
                pdf.summary.splice(existingIndex, 1);
            }
        } else {
            if (existingIndex !== -1) {
                pdf.summary[existingIndex].label = label;
            } else {
                pdf.summary.push({ label: label, page: pageNumber });
            }
        }
        
        pdf.summary.sort((a, b) => a.page - b.page);
        this.setState({ pdf });
    }

    getSummaryLabel(pageNumber) {
        var item = this.state.pdf.summary.find(s => s.page === pageNumber);
        return item ? item.label : "";
    }

    renderEditor() {
        const { pdf, pdf_pages } = this.state;

        return (
            <div className="pdf-editor-container">
                <div className="pdf-editor-header">
                    <button onClick={() => this.redirectToHome()} className="btn-back">
                        Voltar
                    </button>
                    <h1>Editor de Conteúdos PDF</h1>
                    <button onClick={this.onSaveButtonClick} className="btn-save" disabled={this.state.is_saving}>
                        {this.state.is_saving ? 'Salvando...' : 'Salvar'}
                    </button>
                </div>

                <div className="pdf-editor-content">
                    <div className="pdf-editor-sidebar">
                        <div className="form-group">
                            <label>Título</label>
                            <input
                                type="text"
                                value={pdf.title}
                                onChange={this.onTitleChange}
                                placeholder="Título do conteúdo PDF"
                            />
                        </div>

                        <div className="form-group">
                            <label>Imagem de Capa</label>
                            <input
                                type="file"
                                ref={this.coverImageInputRef}
                                accept="image/*"
                                onChange={this.onCoverImageChange}
                                style={{ display: 'none' }}
                            />
                            <div className="cover-preview" onClick={this.onCoverImageClick}>
                                {pdf.thumb ? (
                                    <img src={this.getCoverImage(pdf.thumb)} alt="Capa" />
                                ) : (
                                    <div className="cover-placeholder">Clique para selecionar</div>
                                )}
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Arquivo PDF</label>
                            <input
                                type="file"
                                ref={this.pdfFileInputRef}
                                accept="application/pdf"
                                onChange={this.onPdfFileChange}
                                style={{ display: 'none' }}
                            />
                            <button onClick={this.onPdfFileSelect} className="btn-select-pdf">
                                {pdf.file ? 'Alterar PDF' : 'Selecionar PDF'}
                            </button>
                            {pdf.file && (
                                <p className="file-selected">✓ PDF selecionado</p>
                            )}
                        </div>
                    </div>

                    <div className="pdf-editor-pages">
                        {this.state.is_rendering && (
                            <div className="pdf-rendering-progress">
                                <div className="progress-bar">
                                    <div className="progress-fill" style={{ width: `${this.state.rendering_progress}%` }}></div>
                                </div>
                                <p>Renderizando páginas... {this.state.rendering_progress}%</p>
                            </div>
                        )}
                        <div className="pdf-pages-grid">
                            {pdf_pages.map((page, index) => (
                                <div key={index} className="pdf-page-item">
                                    <div className="pdf-page-thumbnail">
                                        <img src={page.thumbnail} alt={`Página ${page.pageNumber}`} />
                                        <div className="pdf-page-number">Pág. {page.pageNumber}</div>
                                    </div>
                                    <input
                                        type="text"
                                        className="pdf-page-label"
                                        placeholder="Nome do item do sumário"
                                        value={this.getSummaryLabel(page.pageNumber)}
                                        onChange={(e) => this.onSummaryItemChange(page.pageNumber, e.target.value)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLoader() {
        if (!this.state.show_loader) return null;

        return (
            <div className="pdf-editor-loader">
                <div className="loader-content">
                    <div className="spinner"></div>
                    <p>{this.state.loader_text}</p>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="view-pdf-editor">
                {this.renderLoader()}
                {this.renderEditor()}
            </div>
        );
    }
}
